// extracted by mini-css-extract-plugin
export default {"detailsContainer":"Details_detailsContainer__l9Id0","columns":"Details_columns__KT3zp","image":"Details_image__vrrEL","text":"Details_text__vVz88"};